// src/components/ProjectKBanner.jsx
import React from "react";
import "./ProjectKBanner.css";
// assuming you’ve placed your SVG in the same folder as TitleGraphic.svg
import { ReactComponent as TitleGraphic } from "../SVGs/ProjectK.svg";

const ProjectKBanner = ({
  backgroundImage,
  subheading,
  buttonText,
  buttonLink,
}) => (
  <section
    className="projectk-banner"
    style={{ backgroundImage: `url(${backgroundImage})` }}
  >
    <div className="banner-overlay" />

    <div className="banner-container">
      <div className="container banner-content">
        {/* your 3-color fill + 3-color stroke SVG */}
        <TitleGraphic className="banner-title-svg" />

        {subheading && <p className="banner-subheading">{subheading}</p>}

        <a href={buttonLink} className="banner-button">
          {buttonText}
        </a>
      </div>
    </div>
  </section>
);

export default ProjectKBanner;
